<template>
  <div>
    <v-container grid-list-xl fluid>
      <header-title title="Registro"></header-title>
      <v-row class="mb-1" >
        <v-col cols="12" sm="12">
          
          <v-card>
            <v-card-actions>
              <v-card-title>FORMULARIO DE POSTULACIÓN</v-card-title>
              <v-spacer></v-spacer>
              <v-btn color="error" @click="resetFormularioFun()">Reiniciar Formulario</v-btn>
            </v-card-actions>
            <v-dialog v-model="resetFormulario" persistent width="300">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text class="text-center">
          <div >
            <p>¿Esta seguro(a) de Reiniciar el Formulario de Postulación?</p>
            
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="resetForm">
            Aceptar
          </v-btn>
          <v-btn color="error" @click="resetFormulario = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

            <!-- <v-card-text>
              <v-alert text border="left" type="info">
                <span>Para iniciar tu postulación, debes selecciónar tu tipo de postulación de las siguientes opciones.</span>
              </v-alert>
              <v-form ref="formnd" @submit.prevent="guardarTipoPostulacion()">

                <v-radio-group v-model="tipo_postulacion_selected" :disabled="tipo_postulacion !== ''">
                  <v-radio label="Postulantes con discapacidad" value="A2"></v-radio>
                  <v-radio label="Postulantes de Naciones y Pueblos Indígena Originario Campesinos " value="A1"></v-radio>
                  <v-radio label="Postulante en General (con deposito bancario de 108Bs.)" value="A"></v-radio>
                </v-radio-group>
                <v-col cols="12" sm="8" v-if="tipo_postulacion == ''">
                  <v-btn type="submit" large color="primary"  :disabled="tipo_postulacion !== ''">
                    Guardar
                  </v-btn>
                </v-col>
              </v-form>
            </v-card-text> -->


            <v-card-text v-if="tipo_postulacion === 'A'">
              <v-alert text border="left" type="info">
                <span>Es muy importante que verifiques el número de depósito realizado a la Cuenta Corriente Fiscal No. 10000004669343 "Ministerio de Educación - Recursos Propios" en el BANCO UNIÓN S.A. <b>(Ojo: no se acepta transferencias bancarias o pagos mediante QR)</b>.
                  Asegúrate de que no falle ningún dígito y sea igual al de tu
                  recibo.</span>
              </v-alert>
              <p>
               
              </p>
              <v-form ref="formnd" @submit.prevent="checkDeposit()">
                <v-row class="mt-1">
                  <v-col cols="12" sm="4">
                    <v-text-field v-model.trim="postulante.deposito" label="Número de depósito"
                      :rules="[(v) => !!v || 'El campo es requerido']" clearable filled :disabled="type_state == 3"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-btn type="submit" large color="primary" :loading="check_deposit" :disabled="type_state == 3">
                      Verificar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <v-row v-if="type_state === 2">
                <v-col cols="12" class="red--text">
                  Número de depósito no es valido o no está activo.
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <div v-if="type_state === 3">
        <v-form ref="formd" @submit.prevent="showConfirm">
          <v-card class="mb-4">
            <v-card-title class="py-1 blue-grey--text text--darken-2">DATOS PERSONALES</v-card-title>
            <v-card-text>
              <p>
                Ingrese la <b>cédula de identidad</b>
                <span class="red--text"> sin expedido</span>, ejemplo:
                <b>1234567</b>. En caso de tener complemento (EJEMPLO: <b>1G</b>), registrelo en el campo correspondiente.
              </p>
              <v-row class="mt-1">

              </v-row>
              <v-row class="mt-1">
                <!-- <v-col cols="12" sm="3">
                  <v-text-field v-model.trim="postulante.cedula_dni" type="number" label="Cédula de identidad" :rules="[
                    (v) => !!v || 'El campo es requerido',
                    (v) => (!!v && v.length > 3) || 'Mínimo 4 dígitos',
                  ]" hint="1234567" clearable filled></v-text-field>
                </v-col> -->
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model.trim="postulante.cedula_dni"
                    type="text"
                    label="Cédula de identidad"
                    :rules="[
                      (v) => !!v || 'El campo es requerido',
                      (v) => (/^E-\d+$/.test(v) || /^\d+$/.test(v)) || 'Formato incorrecto. Debe ser E- seguido de números o solo números',
                      (v) => (!!v && v.length > 3) || 'Mínimo 4 caracteres',
                    ]"
                    hint="Ejemplo: 1234567 o para extrangeros E-1234567"
                    clearable
                    filled
                    :disabled="datosEncontrados"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="1">
                  <v-text-field v-model.trim="postulante.complemento" maxlength="2" label="Complemento" :rules="[
                  ]" clearable filled 
                    :disabled="datosEncontrados"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-menu v-model="menu_date" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="birthDateFormatted" label="Fecha de nacimiento" append-icon="mdi-calendar"
                        :rules="[(v) => !!v || 'El campo es requerido']" filled readonly v-bind="attrs" v-on="on" 
                    :disabled="datosEncontrados">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model.trim="postulante.fecha_nacimiento" @input="menu_date = false" locale="es">
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <!-- <v-col cols="12" sm="2">
                  <v-select
                    label="Expedido"
                    v-model="postulante.expedido_id"
                    :items="departamentos"
                    item-text="sigla"
                    item-value="id"
                    :rules="[(v) => !!v || 'Seleccione una opción']"
                    filled
                  ></v-select>
                </v-col> -->
                <v-col cols="12" sm="1">
                  <v-btn type="button" large color="primary" :loading="search_loading" @click="searchPostulante" v-if="!datosEncontrados">
                    Guardar
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="4" v-if="datosBuscados">
                  <template>
                    <div class="container">
                      <div class="user-image">
                        <div class="avatar">
                          <v-img lazy-src="../assets/admision/avatar.jpg" :src=imageData contain max-height="150"
                            min-height="100" v-model="fFotografia"></v-img>
                        </div>
                        <div class="icon-wrapper" style="cursor: pointer !important;">
                          <i class="" style="color: #00a8ff;cursor:pointer !important">
                            <v-file-input label="Solo Archivos de Imagen estan permitidos *.jpg, *.jpeg, *.png"
                              accept="image/jpg, image/jpeg, image/png" :rules=reglasImage
                              v-model="fFotografia" ref="file" filled prepend-icon="mdi-camera" chips show-size
                              small-chips @change="verFoto()"></v-file-input>
                          </i>
                        </div>
                        <div class="alert alert-danger" ref="message" hidden>
                          <p>Solo Archivos de Imagen estan permitidos *.jpg, *.jpeg, *.png</p>
                        </div>
                      </div>
                      <!-- <v-btn type="button" small color="secondary" @click="cargarFoto()">
                        Subir Foto
                      </v-btn> -->
                    </div>
                  </template>
                </v-col>
              </v-row>
              <v-row class="mt-1" v-if="datosBuscados">
                <v-col cols="12" sm="4">
                  <v-text-field v-model.trim="postulante.paterno" label="Apellido paterno" :rules="[
                    postulante.materno != ''
                      ? true
                      : (v) => !!v || 'El campo es requerido',
                  ]" @keypress="isText($event)" filled></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field v-model.trim="postulante.materno" label="Apellido materno" :rules="[
                    postulante.paterno != ''
                      ? true
                      : (v) => !!v || 'El campo es requerido',
                  ]" @keypress="isText($event)" filled></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model.trim="postulante.nombres" label="Nombres"
                    :rules="[(v) => !!v || 'El campo es requerido']" @keypress="isText($event)" filled></v-text-field>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-select label="Género" v-model="postulante.genero_id" :items="generos" item-text="descripcion"
                    item-value="id" :rules="[(v) => !!v || 'Seleccione una opción']" filled></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select label="Departamento de nacimiento" v-model="postulante.departamento_id"
                    :items="departamentos" item-text="descripcion" item-value="id"
                    :rules="[(v) => !!v || 'Seleccione una opción']" filled></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field type="number" v-model.trim="postulante.celular" label="Teléfono/Celular" :rules="[
                  (v) => !!v || 'El campo es requerido',
                  (v) => (!!v && v.length == 8) || 'Dato no válido']" filled>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field v-model.trim="postulante.correo_electronico" label="Correo electrónico" :rules="[
                    (v) =>
                      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                      'Correo electrónico no valido',
                  ]" filled></v-text-field>
                </v-col>
                <!-- <v-col cols="12" sm="4">
                  <v-text-field v-model.trim="postulante.direccion" label="Dirección actual" autocomplete="off" filled>
                  </v-text-field>
                </v-col> -->

              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mb-4" v-if="datosBuscados">
            <v-card-title class="py-1 blue-grey--text text--darken-2">DATOS DE DIRECCIÓN</v-card-title>
            <v-card-text>
              <v-row class="mt-1">
                <v-col cols="12" sm="4">
                  <v-select label="Departamento" v-model="postulante.direccion_departamento_id" :items="departamentos"
                    item-text="descripcion" item-value="id" @change="getProvincias()"
                    :rules="[(v) => !!v || 'Seleccione una opción']" filled></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select label="Provincia" v-model="postulante.provincia_id" :items="provincias" item-text="descripcion"
                    item-value="id" @change="getMunicipios()" :rules="[(v) => !!v || 'Seleccione una opción']" filled>
                  </v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select label="Municipio" v-model="postulante.municipio_id" :items="municipios" item-text="descripcion"
                    item-value="id" :rules="[(v) => !!v || 'Seleccione una opción']" filled></v-select>
                </v-col>
                <!-- <v-col cols="12" sm="4">
                  <v-select
                    label="Canton"
                    v-model="canton_id"
                    :items="cantones"
                    item-text="descripcion"
                    item-value="id"
                    @change="getLocalidades()"
                    :rules="[(v) => !!v || 'Seleccione una opción']"
                    filled
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    label="Localidad"
                    v-model="postulante.localidad_id"
                    :items="localidades"
                    item-text="descripcion"
                    item-value="id"
                    :rules="[(v) => !!v || 'Seleccione una opción']"
                    filled
                  ></v-select>
                </v-col> -->
                <v-col cols="12" sm="4">
                  <v-text-field v-model.trim="postulante.direccion_zona" label="Zona" :rules="[
                    (v) => (!!v || this.direccion_requerido) || 'El campo es requerido',
                  ]" autocomplete="off" filled></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field v-model.trim="postulante.direccion_calle" label="Calle" :rules="[
                    (v) => (!!v || this.direccion_requerido) || 'El campo es requerido',
                  ]" autocomplete="off" filled></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field v-model.trim="postulante.direccion_nro" label="Número" :rules="[
                    (v) => (!!v || this.direccion_requerido) || 'El campo es requerido',
                  ]" autocomplete="off" filled></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mb-4" v-if="datosBuscados">
            <v-card-title class="py-1 blue-grey--text text--darken-2">DATOS DE EGRESO</v-card-title>
            <v-card-text>
              <v-row class="mt-1">
                <v-col cols="12" sm="4">
                  <v-text-field v-model.trim="postulante.unidad_educativa" label="Unidad educativa - egreso"
                    :rules="[(v) => !!v || 'El campo es requerido']" filled></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field type="number" v-model.trim="postulante.gestion" label="Gestión de egreso" :rules="[(v) => !!v || 'El campo es requerido',
                  (v) => v < this.postulante.convocatoria || 'Valor no válido'
                  ]" filled></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mb-4" v-if="datosBuscados">
            <v-card-title class="py-1 blue-grey--text text--darken-2">DATOS DE POBLACIÓN INDÍGENA ORIGINARIA CAMPESINA</v-card-title>
            <v-card-text>
              <v-row class="mt-1">
                <!-- <v-col cols="12" sm="6">
                  <v-select label="Lengua Materna" v-model="postulante.lengua_id" :items="lenguas"
                    item-text="descripcion" item-value="id" :rules="[(v) => !!v || 'Seleccione una opción']" filled>
                  </v-select>
                </v-col> -->
                <v-col cols="12" sm="6">
                  <v-select label="Nación o pueblo indigena al que pertenece" v-model="postulante.nacion_pueblo_id"
                    :items="nacion_pueblos" item-text="descripcion" item-value="id"
                    :rules="[(v) => !!v || 'Seleccione una opción']" filled>
                  </v-select>
                </v-col>
                <!-- <v-col cols="12" sm="6">
                  <v-text-field v-model.trim="postulante.pueblo_nacion"
                    label="Nación o pueblo indigena al que pertenece" filled hide-details></v-text-field>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mb-1" v-if="datosBuscados">
            <v-card-title class="py-1 blue-grey--text text--darken-2">DATOS DE POSTULACIÓN</v-card-title>
            <v-card-text>
              <!-- <v-alert text border="left" type="info">
                <span>

                </span>
              </v-alert> -->
              <v-row class="mt-1">
                <v-col cols="12" sm="4">
                  <v-select label="Departamento" v-model="postulante.departameto_id_postulacion" :items="departamentos"
                  item-text="descripcion" item-value="id" @change="getInstitutos()"
                  :rules="[(v) => !!v || 'Seleccione una opción']" filled></v-select>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-select label="Instituto" v-model="postulante.institucion_id" :items="instituciones"
                  item-text="descripcion" item-value="id" @change="getSpecialties()"
                  :rules="[(v) => !!v || 'Seleccione una opción']" filled></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select label="Carrera" v-model="postulante.especialidad_id" :items="especialidades"
                  item-text="descripcion" item-value="id" :rules="[(v) => !!v || 'Seleccione una opción']" filled>
                </v-select>
              </v-col>
            </v-row>
            <v-alert text border="left" type="info" >
                <span>SEGUNDA OPCIÓN DE POSTULACIÓN.</span>
              </v-alert>
             <v-row class="mt-1">
                <v-col cols="12" sm="4">
                  <v-select label="Departamento" v-model="postulante.departamento_id_opcion" :items="departamentos"
                  item-text="descripcion" item-value="id" @change="getInstitutosOpcion()"
                  filled></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select label="Instituto" v-model="postulante.institucion_id_opcion" :items="instituciones_opcion"
                  item-text="descripcion" item-value="id" @change="getSpecialtiesOpcion()"
                   filled></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select label="Carrera" v-model="postulante.especialidad_id_opcion" :items="especialidades_opcion"
                  item-text="descripcion" item-value="id"  filled @change="verificaESFMEspecialidad()">
                </v-select>
              </v-col>
            </v-row>
             
              </v-card-text>
            </v-card>
            <v-card class="mb-1" v-if="datosBuscados">
            <v-card-title class="py-1 blue-grey--text text--darken-2">DATOS DE RECINTO PARA RENDIR LA PRUEBA ACADÉMICA</v-card-title>
            <v-card-text>
 <v-row class="mt-1">
                <v-col cols="12" sm="4">
                  <v-select label="Departamento" v-model="postulante.departameto_id_recinto" :items="departamentos"
                  item-text="descripcion" item-value="id" @change="getRecintos()"
                  :rules="[(v) => !!v || 'Seleccione una opción']" filled></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select label="Recinto" v-model="postulante.recinto_id" :items="recintos"
                  item-text="nombre" item-value="id" 
                  :rules="[(v) => !!v || 'Seleccione una opción']" filled></v-select>
                </v-col>

                <v-col cols="12" sm="4">
                  
              </v-col>
            </v-row>
          </v-card-text>
          </v-card>
          <v-card class="mb-1" v-if="datosBuscados">
             <v-card-title class="py-1 blue-grey--text text--darken-2">DATOS DE DISCAPACIDAD</v-card-title>
            <v-card-text>

               <v-row class="mt-1" >
                <v-col cols="12" sm="4">
                  <v-select label="Tipo de discapacidad" v-model="postulante.discapacidad_id" :items="discapacidades"
                    item-text="descripcion" item-value="id" @change="getGradoDiscapacidad()"
                    :rules="[(v) => !!v || 'Seleccione una opción']" filled></v-select>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-select label="Grado de discapacidad" v-model="postulante.grado_discapacidad_id"
                    :items="grados_discapacidad" item-text="grado_discapacidad.descripcion"
                    item-value="grado_discapacidad_id" :rules="[(v) => (!!v || gradoVacio) || 'Seleccione una opción']"
                    :disabled="gradoVacio" filled></v-select>
                </v-col>
                <v-col cols="12" sm="4" v-if="postulante.discapacidad_id!==5 && postulante.discapacidad_id!==1">
                  <v-text-field label="Porcentaje(%)" type="number" v-model.trim="postulante.grado"
                    :rules="[(v) => !!v || 'El campo es requerido']" filled></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" v-if="postulante.discapacidad_id!==1">
                  <v-menu v-model="disability_date" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="disabilityDateFormatted" label="Fecha de carnet" append-icon="mdi-calendar"
                        :rules="[(v) => !!v || 'El campo es requerido']" filled readonly v-bind="attrs" v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model.trim="postulante.fecha_emision" @input="disability_date = false" locale="es">
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mb-1" v-if="datosBuscados">
            <v-card-text>

              <v-row class="mt-0">
                <v-col cols="12" class="text-center">
                  <v-btn type="submit" large color="primary">
                    <v-icon small>mdi-check</v-icon>
                    Verificar y enviar
                  </v-btn>
                </v-col>
              </v-row>
              <div v-if="estado == 'mensaje'" class="text-center">
                <p class="red--text">{{ message }}</p>
              </div>
            </v-card-text>
          </v-card>
        </v-form>
      </div>
    </v-container>
    <v-dialog v-model="checkDialog" persistent width="300">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text class="text-center">
          <div v-if="response_status == false">
            <p>¿Esta seguro(a) de registrarse?</p>
            <p>
              Verifique sus datos antes de registrar su postulación, no se admitirán
              reclamos posteriores.
            </p>
          </div>
          <div v-else>
            <p class="blue--text">La postulación se realizó existosamente.</p>
            <p>Imprima su Formulario de Postulación.</p>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="response_status == false" color="success" :loading="send_loading" @click="sendResult">
            Aceptar
          </v-btn>
          <v-btn v-else color="success" :loading="send_loading" @click="printForm">
            Imprimir
          </v-btn>
          <v-btn v-if="response_status == false" color="error" @click="checkDialog = false" >
            Cancelar
            <!-- {{ response_status ? "Cerrar" : "Cancelar" }} -->
          </v-btn>
          <v-btn v-else color="error" @click="resetForm" >
            Cerrar
            <!-- {{ response_status ? "Cerrar" : "Cancelar" }} -->
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import HeaderTitle from "@/components/HeaderTitle";
import Service from "../utils/general";
import PDFService from "../utils/pdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { mapActions } from "vuex";
import axios from "axios";


export default {
  name: "admision-registro-a",
  components: {
    HeaderTitle,
  },
  data: () => ({
    resetFormulario: false,
    tipo_postulacion: "",
    tipo_postulacion_selected:"",
    datosEncontrados:false,
    search_loading: false,
    menu_date: false,
    check_deposit: false,
    datosBuscados:false,
    type_state: 1,
    modalidad: "",
    generos: [],
    lenguas: [],
    nacion_pueblos: [],
    departamentos: [],
    provincias: [],
    municipios: [],
    cantones: [],
    localidades: [],
    instituciones: [],
    especialidades: [],
    sedes: [],
    sedes_opcion: [],
    especialidades_opcion: [],
    discapacidades: [],
    grados_discapacidad: [],
    gradoVacio: false,
    instituciones_opcion: [],
    recintos: [],

    postulante: {
      id: "",
      cedula_dni: "",
      complemento: "",
      expedido_id: "",
      paterno: "",
      materno: "",
      nombres: "",
      fecha_nacimiento: "",
      genero_id: "",
      pais_id: "",
      departamento_id: "",
      direccion_departamento_id: "",
      provincia_id: "",
      municipio_id: "",
      localidad_id: "",
      
      grupo_sanguineo_id: "",
      tiene_discapacidad: "NO",
      correo_electronico: "",
      celular: "",
      direccion: "",
      codigo_seguro: "",
      estado: 1,
      //Lengua Originaria de egreso
      lengua_id: "",
      nacion_pueblo_id: "",
      pueblo_nacion: "",
      //Unidad Educativa de egreso
      unidad_educativa_id: "",
      unidad_educativa: "",
      gestion: "",
      
      informacion_academica:[],

      convocatoria_id: "",
      modalidad_id: "",
      deposito: "",
      deposito_id: "",
      institucion_id: "",
      sede_id: "",
      especialidad_id: "",

      institucion_id_opcion: "",
      sede_id_opcion: "",
      especialidad_id_opcion: "",

      parentesco: false,
      parentesco_nombre: "",
      parentesco_cargo: "",

      direccion_zona: "",
      direccion_calle: "",
      direccion_nro: "",

      convocatoria: "",
      ruta_imagen: "",
      descripcion: "",
      tipo: "",
      foto: null,

      profesional:false,
      profesion:"",
      profesion_institucion:"",

      discapacidad_id: "",
      grado_discapacidad_id: "",
      grado: "",
      fecha_emision: "",
      departameto_id_postulacion: "",
      departameto_id_recinto: "",
      recinto_id: "", 
    },
    
    cedula: "",
    fecha_nacimiento: "",
    complemento: "",
    checkDialog: false,
    send_loading: false,
    response_status: false,
    estado: "",
    message: "",
    fFotografia: null, // <- initialize the v-model prop
    imageData: null,
    reglasImage: [
      v => !!v || 'El archivo es Requerido',
      v => (v && v.size > 0) || 'El archivo es Requerido',
    ],
    return: {
      file: ''
    },
    direccion_requerido: true
  }

  ),
  mounted() {
    let params;
    if (Service.getModality()) {
      params = Service.getModality().split("|");
    } else {
      this.$router.replace({ name: "admision-inscripcion" });
    }
    this.postulante.convocatoria_id = params[0];
    this.postulante.modalidad_id = params[1];
    this.modalidad = params[2];
    this.getParameters();
    this.cargaConvocatoria();
    // let user = Service.getUser();
    /* if (user) {
        this.postulante.id = user.uid;
      } else {
        if (this.$router.currentRoute.name != "root") {
          this.$router.push({ name: "root" });
        }
      } */
     this.type_state=3;
  },
  computed: {
    birthDateFormatted() {
      if (!this.postulante.fecha_nacimiento) return null;

      const [year, month, day] = this.postulante.fecha_nacimiento.split("-");
      return `${day}/${month}/${year}`;
    },
    disabilityDateFormatted() {
      if (!this.postulante.fecha_emision) return null;

      const [year, month, day] = this.postulante.fecha_emision.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  methods: {
    ...mapActions(["toast"]),
    getGradoDiscapacidad() {
      this.grados_discapacidad = [];
      this.postulante.grado_discapacidad_id = "";
      axios
        .post(
          Service.getUrlAPI() + "discapacidad/grado_discapacidad",
          { discapacidad_id: this.postulante.discapacidad_id },
          Service.getHeader()
        )
        .then((response) => {
          this.grados_discapacidad = response.data;
          if (this.grados_discapacidad.length == 1 && this.grados_discapacidad[0].grado_discapacidad.descripcion == "") {
            this.postulante.grado_discapacidad_id = this.grados_discapacidad[0].grado_discapacidad_id;
            this.gradoVacio = true;
          } else {
            this.gradoVacio = false;
          }

        })
        .catch(() => {
          console.error("Grados de discapacidad no encontrado");
        });
    },
    resetFormularioFun() {
      this.resetFormulario = true;
    },
    resetForm(){
      window.location.reload();
      this.resetFormulario = false;
    },
    checkDeposit() {
      if (this.$refs.formnd.validate()) {
        this.check_deposit = true;
        axios
          .post(
            Service.getUrlAPI() + "verificar/deposito",
            {
              convocatoria_id: this.postulante.convocatoria_id,
              numero: this.postulante.deposito,
            },
            Service.getHeader()
          )
          .then((response) => {
            this.check_deposit = false;
            this.postulante.deposito_id = response.data.id;
            if (response.data.estado) {
              this.type_state = 3;
            } else {
              this.type_state = 2;
            }
          })
          .catch(() => {
            this.check_deposit = false;
          });
      } else {
        this.toast({ color: "info", text: "Ingrese número de depósito" });
      }
    },
    // guardarTipoPostulacion() {
    //   this.tipo_postulacion= this.tipo_postulacion_selected;
    //   if(this.tipo_postulacion!=="A"){
    //    //parametrizar para pueblos originarios
    //    //parametrizar para discapacidad
    //     this.type_state=3;
    //   }

    // },
    getParameters() {
      axios
        .post(
          Service.getUrlAPI() + "admision/parametro/registro",
          {
            convocatoria_id: this.postulante.convocatoria_id,
            modalidad_id: this.postulante.modalidad_id
          },
          Service.getHeader()
        )
        .then((response) => {
          this.departamentos = response.data.departamentos;
          this.generos = response.data.generos;
          this.instituciones = response.data.instituciones;
          this.lenguas = response.data.lenguas;
          this.nacion_pueblos = response.data.nacion_pueblos;
          this.discapacidades = response.data.discapacidades;
  
        })
        .catch(() => {
          console.error("Parametros no encontrado");
        });
    },
    getSedes() {
      this.sedes = [];
      this.postulante.especialidad_id = "";
      this.postulante.sede_id = "";
      axios
        .post(
          Service.getUrlAPI() + "institucion/sedes",
          { institucion_id: this.postulante.institucion_id },
          Service.getHeader()
        )
        .then((response) => {
          this.sedes = response.data.sedes;
        })
        .catch(() => {
          console.error("Sedes no encontradas");
        });
    },
    getSpecialties() {
      this.especialidades = [];
      this.postulante.especialidad_id = "";
      axios
        .post(
          Service.getUrlAPI() + "institucion/especialidades",
          { institucion_id: this.postulante.institucion_id, convocatoria_id: this.postulante.convocatoria_id },
          Service.getHeader()
        )
        .then((response) => {
          this.especialidades = response.data;
        })
        .catch(() => {
          console.error("Especialidades no encontrado");
        });
    },
    getInstitutos() {
      this.instituciones = [];
      this.postulante.institucion_id = "";
      this.postulante.especialidad_id = "";
      axios
        .post(
          Service.getUrlAPI() + "admision/parametro/institutos",
          { departamento_id: this.postulante.departameto_id_postulacion,
            convocatoria_id: this.postulante.convocatoria_id

          },
          Service.getHeader()
        )
        .then((response) => {
          this.instituciones = response.data.institutos;
        })
        .catch(() => {
          console.error("Institutos no encontrados");
        });
    },
    getInstitutosOpcion() {
      this.instituciones_opcion = [];
      this.postulante.institucion_id_opcion = "";
      this.postulante.especialidad_id_opcion = "";
      axios
        .post(
          Service.getUrlAPI() + "admision/parametro/institutos",
          { departamento_id: this.postulante.departamento_id_opcion, convocatoria_id: this.postulante.convocatoria_id },
          Service.getHeader()
        )
        .then((response) => {
          this.instituciones_opcion = response.data.institutos;
        })
        .catch(() => {
          console.error("Institutos no encontrados");
        });
    },
    getSedesOpcion() {
      this.sedes_opcion = [];
      this.postulante.especialidad_id_opcion = "";
      this.postulante.sede_id_opcion = "";
      axios
        .post(
          Service.getUrlAPI() + "institucion/sedes",
          { institucion_id: this.postulante.institucion_id_opcion },
          Service.getHeader()
        )
        .then((response) => {
          this.sedes_opcion = response.data.sedes;
        })
        .catch(() => {
          console.error("Especialidades no encontrado");
        });
    },
    getSpecialtiesOpcion() {
      this.especialidades_opcion = [];
      this.postulante.especialidad_id_opcion = "";
      axios
        .post(
          Service.getUrlAPI() + "institucion/especialidades",
          { institucion_id: this.postulante.institucion_id_opcion, convocatoria_id: this.postulante.convocatoria_id },
          Service.getHeader()
        )
        .then((response) => {
          this.especialidades_opcion = response.data;
        })
        .catch(() => {
          console.error("Especialidades no encontrado");
        });
    },
    getRecintos() {
      this.recintos = [];
      this.postulante.recinto_id = "";
      axios
        .post(
          Service.getUrlAPI() + "recintos",
          { departamento_id: this.postulante.departameto_id_recinto },
          Service.getHeader()
        )
        .then((response) => {
          this.recintos = response.data.recintos;
        })
        .catch(() => {
          console.error("Recintos no encontrados");
        });
    },
    getProvincias() {
      this.provincias = [];
      this.municipios = [];
      this.postulante.provincia_id = "";
      axios
        .get(Service.getServe() + "provincias/activo/" + this.postulante.direccion_departamento_id,
          Service.getHeader())
        .then((response) => {
          this.provincias = response.data;
        }
        )
        .catch(() => {
          console.error("Provincias no encontradas");
        })
    },
    getMunicipios() {
      this.municipios = [];
      this.postulante.municipio_id = "";
      axios
        .get(Service.getServe() + "municipios/activo/" + this.postulante.provincia_id,
          Service.getHeader())
        .then((response) => {
          this.municipios = response.data;
        }
        )
        .catch(() => {
          console.error("Provincias no encontradas");
        })
    },
    getCantones() {
      this.cantones = [];
      this.postulante.canton_id = "";
      axios
        .get(Service.getServe() + "cantones/activo/" + this.postulante.municipio_id,
          Service.getHeader())
        .then((response) => {
          this.cantones = response.data;
          }
        )
        .catch(() => {
          console.error("Provincias no encontradas");
        })
    },
    getLocalidades() {
      this.localidades = [];
      this.postulante.localidad_id = "";
      axios
        .get(Service.getServe() + "localidades/activo/" + this.postulante.canton_id,
          Service.getHeader())
        .then((response) => {
          this.localidades = response.data;
        }
        )
        .catch(() => {
          console.error("Provincias no encontradas");
        })
    },
    verificaESFMEspecialidad(){
      if(this.postulante.institucion_id_opcion==this.postulante.institucion_id && this.postulante.especialidad_id_opcion==this.postulante.especialidad_id){
           this.toast({ color: "error", text: "La segunda opción de postulación no puede ser igual a la primera opción." });
           this.postulante.especialidad_id_opcion=null;
           
         }
    },
    // Metodo de prueba para probar el servicio de cargado de imagenes.
    cargarFoto() {
      /* Inicializar el FormData */
      let formData = new FormData();

      var extension = this.fFotografia.name.slice(this.fFotografia.name.lastIndexOf('.'));

      /* Adicionar el Form Data que necesitamos enviar */
      formData.append("tipo", 'fotografia');
      formData.append("descripcion", 'fotografia postulacion');
      formData.append("ruta_imagen", Date.now() + extension);

      formData.append("convocatoria", '2023');
      formData.append("estado", true);
      formData.append("persona_id", 2000);

      formData.append("foto", this.fFotografia);
      // console.log(this.fFotografia);
      // console.log(formData);

      /* Crear la respuesta del POST en la URL /single-file */
      var pathServicio = Service.getUrlAPI() + "admision/cargar/fotografia";
      axios.post(pathServicio,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: Service.getTokenExt(),
          },
        }
      ).then(function () {
        console.log('SUCCESS!!');
      })
        .catch(function () {
          console.log('FAILURE!!');
        });
    },

    verFoto() {
      if (!this.fFotografia) {
        this.imageData = "No se eligio ningun archivo"
      }
      else {
        var reader = new FileReader();
        reader.readAsDataURL(this.fFotografia);
        reader.onload = () => {
          this.imageData = reader.result;
        }
      }
    },


    /*
      Manejador para busqueda de archivoa cargar
    */
    buscarArchivo() {
      this.file = this.$refs.file.files[0];

      const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/gif"];

      if (allowedTypes.includes(this.file.type)) {
        this.fichero = this.file;
        this.$refs.message.setAttribute("hidden", true);

      } else {
        this.$refs.message.removeAttribute("hidden");
      }
    },

    searchPostulante() {
      if (
        this.postulante.cedula_dni == "" &&
        this.postulante.fecha_nacimiento == ""
      ) {
        this.toast({
          color: "info",
          text: "Ingrese Cédula de identidad y Fecha de nacimiento",
        });
      } else {
        this.datosBuscados = true;
        //en primera instancia se realiza la busqueda de los datos del postulante en una gestion anterior
        //si no se encuentra los datos se realiza la busqueda en el SIE
        this.search_loading = true;


        this.postulante.paterno = "";
        this.postulante.materno = "";
        this.postulante.nombres = "";

        this.postulante.genero_id = "";
        this.postulante.departamento_id = "";
        this.postulante.celular = "";
        this.postulante.correo_electronico = "";
        // this.postulante.pais_id = "";
        // this.postulante.provincia_id = "";
        // this.postulante.localidad_id = "";

        // this.postulante.grupo_sanguineo_id = "";
        // this.postulante.tiene_discapacidad = "";
        this.postulante.unidad_educativa = "";
        this.postulante.gestion = "";
        this.postulante.direccion = "";
        //this.postulante.codigo_seguro = "";
        // this.postulante.lengua_id = "";
        // this.postulante.pueblo_nacion = "";
        axios
          .post(
            Service.getUrlAPI() + "admision/validar/sie",
            {
              cedula_dni: this.postulante.cedula_dni,
              fecha_nacimiento: this.postulante.fecha_nacimiento,
              complemento: this.postulante.complemento,
            },
            Service.getHeader()
          )
          .then((response) => {
            this.search_loading = false;
            if (response.status === 200) {
              const student = response.data.general;

              this.postulante.informacion_academica = response.data.detalle||"";
              this.postulante.informacion_academica = JSON.stringify(this.postulante.informacion_academica);
              
              //this.postulante.id = response.data.id;
              this.postulante.nombres = student.nombre.trim();
              this.postulante.paterno = student.paterno || "";
              this.postulante.materno = student.materno || "";
              this.postulante.paterno = this.postulante.paterno.trim();
              this.postulante.materno = this.postulante.materno.trim();
              // this.postulante.genero_id = response.data.genero_id;
              // this.postulante.pais_id = response.data.pais_id;
              // this.postulante.departamento_id = response.data.departamento_id;
              // this.postulante.provincia_id = response.data.provincia_id;
              // this.postulante.localidad_id = response.data.localidad_id;
              let lengua = this.lenguas.find(lengua => lengua.descripcion === student.idioma);
              this.postulante.lengua_id = lengua ? lengua.id : "";

              let nacion_pueblo = this.nacion_pueblos.find(nacion => nacion.descripcion === student.nacion_originaria);
              this.postulante.nacion_pueblo_id = nacion_pueblo ? nacion_pueblo.id : "";
              // this.postulante.grupo_sanguineo_id = response.data.grupo_sanguineo_id;
              // this.postulante.tiene_discapacidad = response.data.tiene_discapacidad;
              this.postulante.unidad_educativa = student.institucioneducativa || "";
              this.postulante.gestion = student.gestion_tipo_id || "";
              // this.postulante.direccion = response.data.direccion;
              // this.postulante.correo_electronico = response.data.correo_electronico;
              this.postulante.celular = student.celular || "";
              //this.postulante.codigo_seguro = response.data.codigo_seguro;
              // this.postulante.lengua_id = response.data.lengua_id;
              // this.postulante.pueblo_nacion = response.data.pueblo_nacion;
            } else {
              axios
                .post(
                  Service.getUrlAPI() + "admision/validar/persona/egi",
                  {
                    cedula_dni: this.postulante.cedula_dni,
                    fecha_nacimiento: this.postulante.fecha_nacimiento,
                    complemento: this.postulante.complemento,
                  },
                  Service.getHeader()
                )
                .then((response) => {
                  this.toast({ color: "error", text: "Promedio de Libretas no encontrado"});
                  this.search_loading = false;
                  if (response.status === 200) {
                    const student = response.data;
                    if (student != "") {
                      this.datosEncontrados = true;
                      //this.postulante.id = response.data.id;
                      this.postulante.nombres = student.nombres;
                      this.postulante.paterno = student.paterno || "";
                      this.postulante.materno = student.materno || "";
                      this.postulante.celular = student.celular || "";
                      this.postulante.correo_electronico = student.correo_electronico || "";
                      this.postulante.direccion = student.direccion || "";
                      this.postulante.unidad_educativa = student.recorrido_academicos[0].unidad_educativa || "";
                      this.postulante.gestion = student.recorrido_academicos[0].gestion || "";
                      this.postulante.genero_id = student.genero_id || "";
                      this.postulante.departamento_id = student.departamento_id || "";

                      // this.postulante.genero_id = response.data.genero_id;
                      // this.postulante.pais_id = response.data.pais_id;
                      // this.postulante.departamento_id = response.data.departamento_id;
                      // this.postulante.provincia_id = response.data.provincia_id;
                      // this.postulante.localidad_id = response.data.localidad_id;

                      // this.postulante.grupo_sanguineo_id = response.data.grupo_sanguineo_id;
                      // this.postulante.tiene_discapacidad = response.data.tiene_discapacidad;
                      /* this.postulante.gestion = response.data.datUnidadEducaitva
                        ? response.data.datUnidadEducaitva.gestion
                        : ""; */
                      // this.postulante.direccion = response.data.direccion;
                      // this.postulante.correo_electronico = response.data.correo_electronico;
                      // this.postulante.celular = response.data.celular;
                      //this.postulante.codigo_seguro = response.data.codigo_seguro;
                      // this.postulante.lengua_id = response.data.lengua_id;
                      // this.postulante.pueblo_nacion = response.data.pueblo_nacion;
                    } else {
                      this.toast({ color: "info", text: "Registro no encontrado" });

                    }

                  } else {
                    this.toast({ color: "info", text: "Registro no encontrado" });
                  }
                }

                )
                .catch(() => {
                  this.search_loading = false;
                  console.error("Postulante no encontrado");
                });

            }
          })
          .catch(() => {
            this.search_loading = false;
            console.error("Postulante no encontrado");
          });
      }
    },

    showConfirm() {
      if (
        this.$refs.formd.validate() &&
        this.postulante.cedula_dni != "" &&
        this.postulante.fecha_nacimiento != ""
      ) {
        this.checkDialog = true;
      } else {
        this.toast({ color: "info", text: "Complete el formulario" });
      }
    },
    cargaConvocatoria() {
      axios
        .get(
          Service.getUrlAPI() +
          "admision/obtener/convocatoria/" +
          this.postulante.convocatoria_id,
          Service.getHeader()
        )
        .then((response) => {
          this.postulante.convocatoria = response.data.gestion.toString();
        })
        .catch(() => {
          console.error("datos no encontrado");
        });
    },
    cargarDatosFotografia() {
      //let extension = this.fFotografia.name.slice(this.fFotografia.name.lastIndexOf('.'));
      //this.cargaConvocatoria();
      this.postulante.tipo = "fotografia"
      this.postulante.descripcion = "fotografia postulacion";
      this.postulante.ruta_imagen = Date.now() + ".png";
      this.postulante.foto = this.fFotografia;
    },

    sendResult() {
      this.send_loading = true;
      this.cedula = this.postulante.cedula_dni;
      this.fecha_nacimiento = this.postulante.fecha_nacimiento;
      this.complemento = this.postulante.complemento;
      this.cargarDatosFotografia();

      let fd = new FormData();
      for (let elemento in this.postulante) {
        fd.append(elemento, this.postulante[elemento]);
      }

      this.complemento = this.postulante.complemento;
      axios
        .post(
          Service.getUrlAPI() + "admision/postulante",
          fd,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: Service.getTokenExt(),
            },
          }
        )
        .then((response) => {
          this.send_loading = false;
          if (response.status === 201) {
            //this.checkDialog = false;
            this.response_status = true;
            this.postulante.deposito = "";
            this.postulante.deposito_id = "";
            this.toast({ color: "success", text: response.data });
            this.type_state = 1;
            if (this.$refs.formd) this.$refs.formd.reset();
          } else if (response.status === 200) {
            this.toast({ color: "info", text: response.data });
          }else{
            this.send_loading = false;
          }
        })
        .catch((error) => {
          this.send_loading = false;
          this.toast({ color: "info", text: error.response.data });
          //console.error("Error, no se pudo guardar", error);
        });
    },

    printForm() {
      axios
        .post(
          Service.getUrlAPI() + "admision/comprobante",
          {
            convocatoria_id: this.postulante.convocatoria_id,
            cedula_dni: this.cedula,
            fecha_nacimiento: this.fecha_nacimiento,
            complemento: this.complemento,
            modalidad_id : this.postulante.modalidad_id
          },
          Service.getHeader()
        )
        .then(async (response) => {
          let datos = response.data;
          let codesize = datos.id.toString().length;
          let codigo = "0".repeat(10 - codesize);
          codigo = codigo + datos.id;
          var bodyPdf = await PDFService.bodyPDF(datos, codigo);
          var docDefinition = {
            pageSize: "LETTER",
            pageMargins: [40, 90, 40, 35],
            header: PDFService.setting().header,
            footer: PDFService.setting().footer,
            content: bodyPdf,
          };
          //console.log("this.postulante.modalidad_id",this.postulante.modalidad_id);
          //pdfMake.createPdf(docDefinition).download("FormularioPostulacion.pdf");
          pdfMake.createPdf(docDefinition).open();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    formatDate(fecha) {
      if (!fecha) return null;

      const [year, month, day] = fecha.substring(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },

    isText: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      const codes = [45,46,192,193,196,200,201,203,204,205,207,210,211,214,217,218,220,224,225,228,232,233,235,236,237,239,242,243,246,249,250,252];
      if (codes.includes(charCode) ||
        charCode == 39 ||
        charCode == 32 ||
        charCode == 209 ||
        charCode == 241 ||
        (65 <= charCode && charCode <= 90) ||
        (97 <= charCode && charCode <= 122)
      ) {
        return true;
      } else {
        evt.preventDefault();
        return false;
      }
    },
  },
};
</script>